import React from 'react';
import { PreviewLayerProps } from './Spectogram2';
import { useDragSeek } from './Spectogram2/hooks/useDragSeek';
import Button from '@cube3/ui/src/Buttons/Button';
import { Fade } from '@material-ui/core';
import { PlaybackTimeDisplay } from '@cube3/ui/src/previews/VideoPreview/PlaybackTimeDisplay';
import { convertSecondsToDateFormatCached } from '@cube3/common/utils/convertSecondsToDateFormat';

export const VideoDragSeeek = (props: PreviewLayerProps) => {
  const { assetId, playbackTime = 0, videoRef } = props;

  // normalized playback time (0.0 - 1.0 range)
  const duration = videoRef?.getDuration() || 1;
  const paused = videoRef?.getPausedState();
  const playPos = playbackTime / duration;

  // add event listeners to control current time by dragging mouse
  const {
    handleMouseDown,
    handleClick,
    handleDoubleClick,
    dragging,
    mouseDown
  } = useDragSeek(videoRef);

  return (
    <div
      style={{
        position: 'fixed',
        width: '100%',
        height: '100%'
      }}
    >
      <div
        style={{
          left: 24,
          right: 24,
          top: 48,
          bottom: 48,
          position: 'absolute',
          cursor: mouseDown ? 'col-resize' : 'pointer'
        }}
        onMouseDown={handleMouseDown}
        onClick={handleClick}
        onDoubleClick={handleDoubleClick}
      >
        {/* {playbackTime === 0 && paused && (
          <div
            style={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%) scale(2)'
            }}
          >
            <Button
              pathCenterSvg="iconPlay"
              extraSVGProps={{ svgProps: { viewBox: '0 0 32 32' } }}
              colorVariant="ghost1"
            />
          </div>
        )} */}

        <Fade in={dragging} timeout={{ enter: 350, exit: 1750 }}>
          <div
            style={{
              position: 'absolute',
              top: 10,
              right: 10
            }}
          >
            <PlaybackTimeDisplay
              playedTime={convertSecondsToDateFormatCached(playbackTime)}
              durationDateFormat={convertSecondsToDateFormatCached(duration)}
            />
          </div>
        </Fade>

        <Fade in={dragging} timeout={{ enter: 350, exit: 1250 }}>
          <div
            style={{
              position: 'absolute',
              height: '100%',
              background:
                'linear-gradient(0deg, transparent 0%, white 2%, white 98%, transparent 100%)',
              width: 1,
              top: 0,
              left: `${playPos * 100}%`,
              transform: 'translate(-1px, 0)',
              opacity: 0.5
            }}
          />
        </Fade>
      </div>
    </div>
  );
};
